import { Field, useFormikContext } from "formik";
import Form from "@poseidon/ui/components/form/FullWidthForm";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import Stack from "@mui/material/Stack";
import { TextField, ToggleButtonGroup } from "formik-mui";
import MuiTextField from "@mui/material/TextField";
import ToggleButton from "@mui/material/ToggleButton";
import React from "react";

export const RescheduleForm = () => {
  const { handleSubmit, values } = useFormikContext();
  const { mode, baseRate, addonRate, lumpSum } = values;
  return (
    <Form onSubmit={handleSubmit}>
      <Stack spacing={3} alignItems="start">
        <div>
          <Field
            component={TextField}
            name="addonRate"
            label="Addon Rate"
            InputProps={{
              endAdornment: <InputAdornment position="end">%</InputAdornment>,
              type: "number",
            }}
            margin="none"
          />{" "}
          <MuiTextField
            margin="none"
            sx={{ ml: 2 }}
            disabled
            label="Blended Rate"
            value={`+ ${baseRate}% = ${baseRate + addonRate}%`}
          />
        </div>
        <Field
          component={ToggleButtonGroup}
          name="mode"
          type="checkbox"
          exclusive={true}
        >
          <ToggleButton value="preserve">Preserve Payment</ToggleButton>
          <ToggleButton value="payment">Fixed Payment</ToggleButton>
          <ToggleButton value="term">Fixed Term</ToggleButton>
        </Field>
        {mode === "term" && (
          <Field
            component={TextField}
            name="term"
            label="Term"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">months</InputAdornment>
              ),
              type: "number",
            }}
            margin="normal"
          />
        )}
        {mode === "payment" && (
          <Field
            component={TextField}
            name="repayment"
            label="Monthly Payment"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">£</InputAdornment>
              ),
              type: "number",
            }}
            margin="normal"
          />
        )}
        <Field
          component={TextField}
          name="balloon"
          label="Balloon"
          helperText="Final instalment carried forward. Leave as-is to preserve; set 0 to remove."
          InputProps={{
            startAdornment: <InputAdornment position="start">£</InputAdornment>,
            type: "number",
            inputProps: {
              step: "500",
            },
          }}
          margin="normal"
        />
        <Field
          component={TextField}
          name="lumpSum"
          label="Lump Sum"
          InputProps={{
            startAdornment: <InputAdornment position="start">£</InputAdornment>,
            type: "number",
          }}
          margin="normal"
        />
        <Field
          component={TextField}
          name="holidayMonths"
          label="Payment Holiday"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">months</InputAdornment>
            ),
            type: "number",
          }}
          margin="normal"
        />

        <div>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            margin="normal"
            sx={{ mt: 1 }}
          >
            Preview
          </Button>
        </div>
      </Stack>
    </Form>
  );
};
